import type { ReactElement } from "react";

export enum RecentType {
    Website = "website",
    Keyword = "keyword",
    Advertiser = "advertiser",
    Publisher = "publisher",
}

export interface IRecentItem {
    name: string;
    element?: ReactElement;
    icon?: string;
}

export interface IRecentItemFilter {
    text: string;
    icon: ReactElement;
    hidden: boolean;
}
